export const Color = {
  jaune: "#FCAE3B",
  bleu: "#0B3D68",
  vert: "#1AA981",
  themeColor: "#0B3D68",
  loaderColor: "#d96408",
  rouge: "#E73628",
  success: "#1AA981",
  default: "#0B3D68",
  danger: "#E73628",
};

export const Font = {
  family: "#Montserrat",
};
